import { Container } from '@/lib/core/components/Badge/Badge.styles'

import { BadgeProps, BadgeVariant } from './Badge.types'
import { getContrastColor } from './Badge.utils'

export const Badge = ({
  children,
  minSize = 8,
  variant,
  backgroundColor,
  textColor,
  onClick,
}: BadgeProps) => {
  // For TAG variant, automatically determine text color if not provided
  const computedTextColor =
    variant === BadgeVariant.TAG && backgroundColor && !textColor
      ? getContrastColor(backgroundColor)
      : textColor

  return (
    <Container
      onClick={onClick}
      $size={minSize}
      $variant={variant}
      $backgroundColor={backgroundColor}
      $textColor={computedTextColor}
      $hasChildren={!!children}
    >
      {children}
    </Container>
  )
}
